/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Create_Name_MaxInputs */



/**
* | output |
* | --- |
* | "Space name must be less than 50 characters" |
*
* @param {Spaces_Create_Name_MaxInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_create_name_max = /** @type {((inputs?: Spaces_Create_Name_MaxInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Create_Name_MaxInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Der Spacename darf höchstens 50 Zeichen lang sein")
	return /** @type {LocalizedString} */ ("Space name must be less than 50 characters")
});